import bgBG from "./bg-BG.json"
import cs from "./cs-CZ.json"
import de from "./de-DE.json"
import el from "./el-GR.json"
import en from "./en-US.json"
import es from "./es-ES.json"
import frFR from "./fr-FR.json"
import itIT from "./it-IT.json"
import nlNL from "./nl-NL.json"
import nb from "./no-NO.json"
import plPL from "./pl-PL.json"
import roRO from "./ro-RO.json"
import svSE from "./sv-SE.json"

export default {
	de,
	en,
	es,
	el,
	bg: bgBG,
	cs,
	fr: frFR,
	it: itIT,
	nb,
	nl: nlNL,
	pl: plPL,
	ro: roRO,
	sv: svSE,
}
